import { useLang } from "../../core/lang";
import LangKeys from "../../core/locales/keys";

function BackupInformationPage() {
  const { t } = useLang();

  const lastBackupTime =
    new Date().toLocaleString();

  return (
    <div style={styles.page}>
      <div style={styles.infoCard}>
        <div style={styles.infoText}>
          {t(LangKeys.backup_info_text)}
        </div>
      </div>

      <div style={styles.backupCard}>
        <div style={styles.label}>
          {t(LangKeys.last_backup_at)}
        </div>

        <div style={styles.time}>
          {lastBackupTime}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    padding: "16px",
  },

  infoCard: {
    backgroundColor: "#fff",
    borderRadius: "18px",
    padding: "18px",
    border: "1px solid #E5E7EB",
    marginBottom: "16px",
  },

  infoText: {
    fontSize: "14px",
    color: "#374151",
    lineHeight: "1.7",
  },

  backupCard: {
    backgroundColor: "#fff",
    borderRadius: "18px",
    padding: "18px",
    border: "1px solid #E5E7EB",
  },

  label: {
    fontSize: "12px",
    color: "#6B7280",
    marginBottom: "6px",
  },

  time: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#111827",
  },
};

export default BackupInformationPage;